module.exports = __webpack_public_path__ + "img/map.6acbe750.svg";